// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-relatorios {
  padding: 0 !important;
}

.relatorios-filter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
}

.relatorios-filter label {
  font-weight: 600;
  color: #25324b;
  padding-left: 6px;
}

.relatorios-filter select {
  min-width: 240px;
  max-width: 360px;
  width: 100%;
  border: 1px solid #c6d1eb;
  border-radius: 8px;
  background: #ffffff;
  color: #25324b;
  padding: 10px 12px;
}

.relatorios-filter select:disabled {
  background: #f2f4fa;
  color: #7080a0;
}

.relatorios-frame {
  width: 100%;
  height: 100vh;
  border: none;
  border-radius: 8px;
  background: #ffffff;
}

.relatorios-loading {
  padding: 24px;
  text-align: center;
  color: #4a5a85;
}

.no-movements{
  padding: 40px;
}

.relatorios-frame-wrap {
  position: relative;
}

/* Cobre o iframe enquanto o relatório da unidade carrega */
.relatorios-skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 8px;
  background: #ffffff;
}

.relatorios-skeleton .skeleton-stack {
  padding: 0;
}

.relatorios-skeleton-title .skeleton-line {
  max-width: 320px;
  height: 22px;
}

.relatorios-skeleton-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.relatorios-skeleton-card {
  height: 96px;
  border-radius: 10px;
}

.relatorios-skeleton-chart {
  height: 280px;
  border-radius: 10px;
}

.relatorios-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 20px;
  padding: 64px 24px;
  border: 1px dashed #c6d1eb;
  border-radius: 12px;
  background: #f7f9fd;
  color: #4a5a85;
  text-align: center;
}

.relatorios-filter + .relatorios-frame-wrap .relatorios-empty {
  margin-top: 0;
}

.relatorios-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 8px;
  border-radius: 50%;
  background: #e3e9f7;
  color: #25324b;
  font-size: 30px;
}

.relatorios-empty h3 {
  margin: 0;
  color: #25324b;
  font-size: 20px;
}

.relatorios-empty p {
  margin: 0;
  font-size: 15px;
}

.relatorios-empty span {
  max-width: 420px;
  font-size: 13px;
  color: #7080a0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Relatorios/relatorios.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".container-relatorios {\n  padding: 0 !important;\n}\n\n.relatorios-filter {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 20px;\n}\n\n.relatorios-filter label {\n  font-weight: 600;\n  color: #25324b;\n  padding-left: 6px;\n}\n\n.relatorios-filter select {\n  min-width: 240px;\n  max-width: 360px;\n  width: 100%;\n  border: 1px solid #c6d1eb;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #25324b;\n  padding: 10px 12px;\n}\n\n.relatorios-filter select:disabled {\n  background: #f2f4fa;\n  color: #7080a0;\n}\n\n.relatorios-frame {\n  width: 100%;\n  height: 100vh;\n  border: none;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.relatorios-loading {\n  padding: 24px;\n  text-align: center;\n  color: #4a5a85;\n}\n\n.no-movements{\n  padding: 40px;\n}\n\n.relatorios-frame-wrap {\n  position: relative;\n}\n\n/* Cobre o iframe enquanto o relatório da unidade carrega */\n.relatorios-skeleton {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.relatorios-skeleton .skeleton-stack {\n  padding: 0;\n}\n\n.relatorios-skeleton-title .skeleton-line {\n  max-width: 320px;\n  height: 22px;\n}\n\n.relatorios-skeleton-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n}\n\n.relatorios-skeleton-card {\n  height: 96px;\n  border-radius: 10px;\n}\n\n.relatorios-skeleton-chart {\n  height: 280px;\n  border-radius: 10px;\n}\n\n.relatorios-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 20px;\n  padding: 64px 24px;\n  border: 1px dashed #c6d1eb;\n  border-radius: 12px;\n  background: #f7f9fd;\n  color: #4a5a85;\n  text-align: center;\n}\n\n.relatorios-filter + .relatorios-frame-wrap .relatorios-empty {\n  margin-top: 0;\n}\n\n.relatorios-empty-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 8px;\n  border-radius: 50%;\n  background: #e3e9f7;\n  color: #25324b;\n  font-size: 30px;\n}\n\n.relatorios-empty h3 {\n  margin: 0;\n  color: #25324b;\n  font-size: 20px;\n}\n\n.relatorios-empty p {\n  margin: 0;\n  font-size: 15px;\n}\n\n.relatorios-empty span {\n  max-width: 420px;\n  font-size: 13px;\n  color: #7080a0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
